//
// Form Collections
//
// Generic class for symfony form collections (A collection of forms)
// Simply pass your form config to the constructor, this class will handle the adding and removing of form entries.
// See https://symfony.com/doc/2.8/form/form_collections.html
//
// ---------------------------------------------------------------------------

'use strict';

const config = {
    clickEvents: 'click touch',
    addTarget: '.js-add-item',
    deleteTarget: '.js-delete-list-item'
};

export default class FormCollection {

    /**
     * @param {object} options
     */
    constructor(options) {
        const Collection = this;

        options.$collectionContainer.find(options.formSelector).each(function() {
            Collection.setupDeleteLink($(this));
        });

        // count the current form inputs we have (e.g. 2), use that as the new
        // index when inserting a new item (e.g. 2)
        options.$collectionContainer.data('index', options.$collectionContainer.find(options.formSelector).length);

        // If we are expecting an initial set of empty form entries on the page, add the appropriate form elements.
        if (options.initialSize && options.$collectionContainer.data('index') < options.initialSize) {
            for (let i = options.$collectionContainer.data('index'); i < options.initialSize; i++) {
                Collection.addNewForm(
                    options.$collectionContainer,
                    options.prototypeRegex,
                    options.postAdd
                );
            }
        }

        // Handler for adding new form row.
        $(config.addTarget).on(config.clickEvents, function(e) {

            // prevent the link from creating a "#" on the URL
            e.preventDefault();

            Collection.addNewForm(
                options.$collectionContainer,
                options.prototypeRegex,
                options.postAdd
            );
        });
    }

    /**
     * @param {jQuery} $form
     */
    setupDeleteLink($form) {
        $(config.deleteTarget, $form).on(config.clickEvents, function(e) {
            e.preventDefault();
            $form.remove();
        });
    }

    /**
     * @param {jQuery} $collectionContainer
     * @param {RegExp} prototypeRegex
     * @param {function} postAdd
     */
    addNewForm(
        $collectionContainer,
        prototypeRegex,
        postAdd
    ) {
        const prototype = $collectionContainer.data('prototype');
        const index = $collectionContainer.data('index');
        let newForm = prototype;

        // increase the index with one for the next item
        $collectionContainer.data('index', index + 1);

        // Replace placeholder in the prototype's HTML to
        // instead be a number based on how many items we have
        newForm = newForm.replace(prototypeRegex, index);

        const $newForm = $(newForm);

        $collectionContainer.append($newForm);

        // add a delete link to the new form
        this.setupDeleteLink($newForm);

        if (postAdd) {
            postAdd($newForm);
        }
    }

}



// WEBPACK FOOTER //
// ./src/js/components/form-collection.js